import alert from '@/plugins/alert'
import { Product } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    products: {},
    count: 0
  },
  actions: {
    async fetchProducts ({ commit }, options) {
      commit('setProducts', await Product.fetch(options))
    },
    async countProducts ({ commit }, options) {
      commit('setCount', await Product.count(options))
    },
    async fetchProduct ({ commit }, productId) {
      commit('setProduct', await Product.fetchOne(productId))
    },
    async createProduct ({ commit }, { data, options }) {
      commit('setProduct', await Product.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async updateProduct ({ commit }, { id, ...product }) {
      commit('setProduct', await Product.update(id, product))
      alert.success('Cập nhật thành công!')
    },
    async removeProduct ({ commit }, id) {
      await Product.remove(id)
      commit('removeProduct', id)
      alert.success('Xóa thành công!')
    },
    setProduct ({ commit, state }, product) {
      commit('setProduct', product)
    },
    async removeProducts ({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeProduct', item.id)
      }
    },
    async updateProducts ({ dispatch }, items) {
      await Promise.all(items.map(item => dispatch('updateProduct', item)))
    }
  },
  mutations: {
    setProducts (state, products) {
      state.products = products.reduce((accumulator, currentValue) => ({
        ...accumulator,
        [currentValue.id]: currentValue
      }), {})
    },
    setProduct (state, product) {
      state.products = {
        ...state.products,
        [product.id]: product
      }
    },
    removeProduct (state, productId) {
      delete state.products[productId]
      state.products = { ...state.products }
    },
    setCount (state, count) {
      state.count = count
    }

  },
  getters: {
    products: (state) => {
      return Object.values(state.products)
    },
    product: (state) => (id) => {
      return state.products[id]
    },
    count: (state) => {
      return state.count
    }
  }
}
